<template>
    <div>Descargando...</div>
</template>

<script>
export default {
    name: 'descargarNota',
    props:['params'],
    created(){
        if(this.params){
            //window.location = "http://r1.bdtr.net/hls/nph-send.mpg?"+this.params
            window.location = "https://d8.bdtr.net/hls/nph-send.mpg?"+this.params
        }else{
            this.$router.push('/');
        }
    }
}
</script>